export const MAX_IOS_SIDE_SIZE = 1500

export const isInvalidIOSSize = (w, h) => {
  return navigator.userAgent.indexOf('Safari') > -1
    && navigator.userAgent.indexOf('iPhone') > -1
    && w * h > MAX_IOS_SIDE_SIZE*MAX_IOS_SIDE_SIZE
}

export const calculateIOSCanvasSize = (w, h) => {
  w = Number(w)
  h = Number(h)
  const isWidthMax = w > h
  const k = MAX_IOS_SIDE_SIZE/(isWidthMax ? w : h)

  return {
    width: isWidthMax ? MAX_IOS_SIDE_SIZE : Math.round(w*k),
    height: !isWidthMax ? MAX_IOS_SIDE_SIZE : Math.round(h*k)
  }
}

export const replaceCoordinates = (realW, realH, resizedW, resizedH, coordinates) => {
  realW = Number(realW)
  realH = Number(realH)
  resizedW = Number(resizedW)
  resizedH = Number(resizedH)

  const wK = realW / resizedW
  const hK =  realH / resizedH

  return rReplaceCoordinatesByK(coordinates, wK, hK)
}

export const rReplaceCoordinatesByK = (coordinates, wK, hK) => {
  if (coordinates.length === 2 && !(coordinates[0] instanceof Array) && !(coordinates[1] instanceof Array)) {
    return [Math.round(coordinates[0]*wK), Math.round(coordinates[1]*hK)]
  }

  return coordinates.map(c => {
    if (c instanceof Array) {
      if (c.length === 2 && !(c[0] instanceof Array) && !(c[1] instanceof Array)) {
        return [Math.round(c[0]*wK), Math.round(c[1]*hK)]
      } else {
        return rReplaceCoordinatesByK(c, wK, hK)
      }
    }

    return c
  })
}
